/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useRef } from "react";
import { useWorkingHours } from "./WorkingHoursContext";
import socket from "../socket";

export const useChefAutoOffline = (chefId?: string) => {
  // ✅ chefId optional
  const { workingHours, manualToggle, setShowOfflinePopup } = useWorkingHours();
  const timeoutsRef = useRef<NodeJS.Timeout[]>([]);

  useEffect(() => {
    if (!workingHours || !chefId) return; // handle undefined safely

    // clear old timers
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];

    const today = new Date()
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();
    const todaysSlots = workingHours[today] || [];

    todaysSlots.forEach((slot) => {
      const [eHour, eMin] = slot.end.split(":").map(Number);
      const now = new Date();
      const endTime = new Date();
      endTime.setHours(eHour, eMin, 0, 0);
      const diff = endTime.getTime() - now.getTime();
      // 🔹 Show popup 15 min before
      const warningTime = diff - 2 * 60 * 1000;
      
      if (warningTime > 0) {
        const warnTimeout = setTimeout(() => {
          setShowOfflinePopup(true); // show popup
        }, warningTime);
        timeoutsRef.current.push(warnTimeout);
      }
      if (diff > 0 && !manualToggle) {
        const t = setTimeout(() => {
          if (!socket.connected) socket.connect();
          if (!manualToggle) {
            socket.emit("changeChefStatus", { chefId, status: false });
            setShowOfflinePopup(false);
            
          }
        }, diff);
        timeoutsRef.current.push(t);
      }
    });

    return () => {
      timeoutsRef.current.forEach(clearTimeout);
    };
  }, [workingHours, chefId, manualToggle, setShowOfflinePopup]);
};
